import { Column, Main, Row, SummaryColumn, Wrapper } from './components';

const Layout = { Column, Main, Row, SummaryColumn, Wrapper };

export default Layout;
